import React, {useContext, useEffect, useState} from 'react';
import {Helmet} from 'rnd-helmet';
import {injectIntl} from "react-intl";
import Form from 'form';
import dispatchRerender from 'dispatchRerender';
import FormContext from "formContext";
import axios from 'axios';
import { useDataLayer} from "dataLayerHelper";
import SubMenu from "@Components/SubMenu";
import RegisterMetaBlock from "@Components/RegisterMetaBlock";
import useRegisterSubmitHandler from 'registerSubmitHandler';
import NoticeInPageCutover from "@Components/NoticeInPageCutover";

function Register({intl, match, staticContext}) {
  const headerTitleLeft = intl.formatMessage({id: "Register.Header.Title.Left"});
  const {setAdditionalData, formData, setFormData, currentStep, setErrors, additionalData} = useContext(FormContext);
  const {handleRegisterSubmit} = useRegisterSubmitHandler();
  const cutoverMrndRegisterSettings = additionalData?.cutoverSettings?.myrandstad_register || {};

  const { locale } = intl;

  // Generate dataLayer for the page.
  useDataLayer(locale, staticContext);
  useEffect(() => {
    if (window.__ROUTE_DATA__) {
      delete window.__ROUTE_DATA__;
    }
    else {
      Promise.all([
        axios.get(`${process.env.REACT_APP_API_PREFIX}/job-categories-list`),
      ])
        .then(([jobCategoriesListResponse]) => {
          setAdditionalData({
            qualifications: jobCategoriesListResponse?.data?.qualifications,
            }
          );
        });
    }

    dispatchRerender();
    setFormData({
      [currentStep]: {
        CountryID: 78, // France is default.
        Apply: true // Send CV checked by default
      }
    });
  }, []);

  const handleChange = event => {
    let name = event.target.name;
    let value = event.target.value;
    if (event.target.type === 'checkbox') {
      let checkboxValue = event.target.value;
      if (typeof checkboxValue === 'string' && checkboxValue === 'true') {
        checkboxValue = true;
      }
      value = event.target.checked ? checkboxValue : null;
    }

    setFormData((prev) => {
      if (!prev[currentStep]) {
        prev[currentStep] = {};
      }
      prev[currentStep][name] = value;
      return {
        ...prev
      }
    });

    setErrors((prev) => {
      if (prev && prev.hasOwnProperty(name) && value) {
        delete prev[name];
      }

      return {
        ...prev,
      };
    });
  };

  const handleSubmit = event => {
    event.preventDefault();
    handleRegisterSubmit();
  };

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({ id: "Menu.Register" })} |{" "}
          {intl.formatMessage({ id: "Breadcrumb.Dashboard" })}
        </title>
        <header className="header header--text bg-variant-brand-primary" />
      </Helmet>
      <div className="header header--text header--compact bg-variant-brand-primary">
        <div className="header__wrapper wrapper">
          <SubMenu />
          <div className="header__content header__content--l content-block header__content--full-width has-breadcrumbs">
            <h1 className="content-block__title">
              <span className="content-block__title-top">
                {headerTitleLeft}
              </span>
            </h1>
          </div>
        </div>
      </div>
      <div className="wrapper l:flex justify-between flex-col l:flex-row bluex-form-strip-spaces pt-m l:pt-l l:pb-xxl">
        <div className="w-1/2">
          <NoticeInPageCutover settings={cutoverMrndRegisterSettings} />
          <Form
            name="register"
            handleChange={handleChange}
            state={formData[currentStep]}
            handleSubmit={handleSubmit}
            hideGeneralErrors={false}
            stackLayout={true}
          />
        </div>
        <div className="w-5/12">
          <RegisterMetaBlock />
        </div>
      </div>
    </>
  );
}

export default injectIntl(Register);
